import React from 'react';
import { useDrag } from 'react-dnd';
import { List, Typography } from 'antd';
import { ToolboxFormItem } from './index';
import styles from './styles.module.pcss';

type Props = {
  formItem?: ToolboxFormItem | null;
};

const ToolbarItem: React.FC<Props> = ({ formItem }) => {
  const [{ isDragging, handlerId }, drag] = useDrag(() => ({
    type: 'TOOLBARITEM',
    item: formItem,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }));

  return (
    <List.Item
      ref={drag}
      data-testid={handlerId}
      className={styles.toolbarItem}
      style={{
        opacity: isDragging ? 0.4 : 1,
      }}
    >
      <Typography.Text>{formItem?.label}</Typography.Text>
    </List.Item>
  );
};

export default ToolbarItem;
